import { Component, Input, OnInit } from '@angular/core';

import {
  trigger,
  state,
  style,
  animate,
  transition,
  query,
  animateChild,
  stagger,
  group,
} from '@angular/animations';
export class ModalComponent implements OnInit {
   isOpen: any;
constructor() {}
/**
 * @return {?}
 */
ngOnInit() {}
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'tnk-modal',
  template: `
    <div class="tnk-modal" [@modalState]="isOpen">
      <div class="tnk-modal__dialog" [@modalDialogState]="isOpen">
        <ng-content></ng-content>
        <ng-content select="tnk-modal-header"></ng-content>
        <ng-content select="tnk-modal-body"></ng-content>
        <ng-content select="tnk-modal-footer"></ng-content>
      </div>
      <span class="tnk-modal__backdrop"></span>
    </div>
  `,
  animations: [
    trigger(`modalState`, [
      state(
        'false',
        style({
          display: 'none',
          visibility: 'hidden',
          opacity: '0',
        }),
      ),
      state(
        'true',
        style({
          display: 'block',
          visibility: 'visible',
          opacity: '1',
        }),
      ),
      transition('false <=> true', [
        group([
          query('@modalDialogState', [animateChild()]),
          animate('250ms ease-in-out'),
        ]),
      ]),
    ]),
    trigger(`modalDialogState`, [
      state(
        'false',
        style({
          transform: 'translate(-50%, 100%)',
        }),
      ),
      state(
        'true',
        style({
          transform: 'translate(-50%, -50%)',
        }),
      ),
      transition('false <=> true', animate('250ms ease-in-out')),
    ]),
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'isOpen': [{ type: Input },],
};
}

function ModalComponent_tsickle_Closure_declarations() {
/** @type {?} */
ModalComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ModalComponent.ctorParameters;
/** @type {?} */
ModalComponent.propDecorators;
/** @type {?} */
ModalComponent.prototype.isOpen;
}

export class ModalHeaderComponent implements OnInit {
constructor() {}
/**
 * @return {?}
 */
ngOnInit() {}
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'tnk-modal-header',
  template: `
    <div class="tnk-modal__header">
      <ng-content></ng-content>
    </div>
  `,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ModalHeaderComponent_tsickle_Closure_declarations() {
/** @type {?} */
ModalHeaderComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ModalHeaderComponent.ctorParameters;
}

export class ModalBodyComponent implements OnInit {
constructor() {}
/**
 * @return {?}
 */
ngOnInit() {}
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'tnk-modal-body',
  template: `
    <div class="tnk-modal__body">
      <ng-content></ng-content>
    </div>
  `,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ModalBodyComponent_tsickle_Closure_declarations() {
/** @type {?} */
ModalBodyComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ModalBodyComponent.ctorParameters;
}

export class ModalFooterComponent implements OnInit {
constructor() {}
/**
 * @return {?}
 */
ngOnInit() {}
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'tnk-modal-footer',
  template: `
    <div class="tnk-modal__footer">
      <ng-content></ng-content>
    </div>
  `,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ModalFooterComponent_tsickle_Closure_declarations() {
/** @type {?} */
ModalFooterComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ModalFooterComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
